import { $mount } from '../../../js/dom-lifecycle';

const beforeUnloadHandler = e => e.preventDefault();

$mount('#stock-update-form')
    .on('input', 'input[name^="stock["]', function () {
        $('.batch-actions').prop('hidden', false);
        window.addEventListener('beforeunload', beforeUnloadHandler);
    })
    .on('submit', () => window.removeEventListener('beforeunload', beforeUnloadHandler));
